import { useRouter } from "next/navigation";
import React from "react";
import { FaArrowRight } from "react-icons/fa6";

export default function Button({ text, link }) {
  const router = useRouter();

  return (
    <button
      onClick={() => router.push(link)}
      className="bg-[#020202] text-white font-medium text-sm md:text-lg py-[14px] px-6 rounded-[6px] flex justify-center items-center gap-4 hover:bg-primary duration-300"
      style={{ whiteSpace: "nowrap" }}
    >
      {text}
      <FaArrowRight />
    </button>
  );
}
